/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "../ui/Title";
import Text from "../ui/Text";
import Button from "../ui/Button";
import Icon from "../ui/Icon";
import FormatDateTime from "../formatters/FormatDateTime";
import T from "../ui/Translation";
import WaitingListAction from "./WaitingListAction";
import Stack from "../ui/Stack";

const StyledCalendarBookedState = styled(Stack)`
  text-align: center;
`;

const CalendarBookedStateIcon = styled((props) => <Icon.CalendarCheck {...props} />)`
  margin: 0 auto;
`;

const CalendarBookedState = ({ 
  firstAvailableDay,
  coverageExhausted,
  onButtonClick,
  selectedDate,
  canJoinWaitingList,
}) => {
  return (
    <StyledCalendarBookedState $gap="1.5rem" $align="center"> 
      <Stack $gap="1rem" $align="center">
        <CalendarBookedStateIcon size={Icon.SIZE.XL} />
        <Stack $gap="0.5rem">
          <Title size="h2">This day is fully booked</Title>
          {firstAvailableDay ? (
            <Stack $gap="0.25rem">
              <Text color="dark">Next available date is:</Text>
              <Text color="dark">
                <FormatDateTime value={firstAvailableDay} format={FormatDateTime.FORMAT.DATE} />
              </Text>
            </Stack>
          ) : coverageExhausted ? (
            <Text color="dark">
              <T>No available times within your membership validity period</T>
            </Text>
          ) : null}
        </Stack>

        {!!firstAvailableDay && (
          <Button variant="primary" onClick={onButtonClick} title="find_next_available_day" />
        )}
      </Stack>

      {canJoinWaitingList && (
        <WaitingListAction selectedDate={selectedDate} withDivider={!!firstAvailableDay} />
      )}
    </StyledCalendarBookedState>
  );
};

export default CalendarBookedState;
